import * as React from 'react';
import './Footer.css';
import { ArrowUpward } from '@mui/icons-material';

const scrollToTop = () => {
    if (document.body.scrollTop) {
        document.body.scrollTop = 0;
        return;
    }

    if (document.documentElement.scrollTop) {
        document.documentElement.scrollTop = 0;
        return;
    }
};

export default () => (
    <div>
        <div className="footer">
            <div className="copyright-container center-children-vertically" >
                <div className="copyright">{"BHP " + (new Date().getFullYear())}</div>
            </div>

            <div className="arrow center-children-both clickable" title="Go to the top" onClick={scrollToTop} >
                <ArrowUpward />
                <div className="footer-top-nav-text">Go to the top</div>
            </div>
        </div>
    </div>
);